import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleAuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await googleSession(sessionId);
        navigate("/", { replace: true });
      } catch (err) {
        setError(err.response?.data?.detail || "Google sign-in failed. Please try again.");
      }
    })();
  }, [googleSession, navigate]);

  return (
    <div className="min-h-screen bg-tac-bg flex items-center justify-center px-4" data-testid="google-auth-callback">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-sm text-tac-danger mb-4" data-testid="google-auth-error">{String(error)}</p>
            <button
              type="button"
              data-testid="google-auth-back-to-login"
              onClick={() => navigate("/login", { replace: true })}
              className="px-4 py-2 bg-tac-primary text-white text-xs font-bold uppercase tracking-wider rounded-sm"
            >
              Back to log in
            </button>
          </>
        ) : (
          <>
            <div className="w-8 h-8 border-2 border-tac-primary border-t-transparent rounded-full animate-spin mx-auto mb-3" />
            <p className="text-xs uppercase tracking-[0.15em] text-tac-dim font-bold">Signing you in…</p>
          </>
        )}
      </div>
    </div>
  );
}
